import { jsx as _jsx, jsxs as _jsxs } from 'react/jsx-runtime.js';
import { Flex } from '@stepstone-genesis/components';
import { Benefits } from './Benefits.js';
import { BrandLogo } from '../BrandLogo.js';
import { ContentHeader } from './ContentHeader.js';
export const DefaultContent = () => {
    return (_jsxs(Flex, { flxDirection: 'column', pb: ['spaceNone', 'spaceXl'], children: [_jsx(BrandLogo, {}), _jsxs(Flex, { flxDirection: 'column', gap: ['spaceM', 'spaceL', 'spaceXl'], pt: ['spaceXxl', 'spaceXl'], pb: 'spaceM', children: [_jsx(ContentHeader, {}), _jsx(Benefits, {})] })] }));
};
//# sourceMappingURL=DefaultContent.js.map